export default __webpack_public_path__ + "media/Slice-1.bd67255c.png";